import { render, staticRenderFns } from "./ClinicLog.vue?vue&type=template&id=97e8312c&scoped=true"
import script from "./ClinicLog.vue?vue&type=script&lang=js"
export * from "./ClinicLog.vue?vue&type=script&lang=js"
import style0 from "./ClinicLog.vue?vue&type=style&index=0&id=97e8312c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e8312c",
  null
  
)

export default component.exports